module.exports = __webpack_public_path__ + "media/images/red-pencil-box-c09a938d92aeb5ffafff807edc86f437.svg";